/**
 * Which coach a route has (route path → module guide key).
 *
 * Split out of guideContent.ts on 4 Oct 2026: the shell (AppLayout,
 * PageHeader) only asks "does this page have a coach?", and importing the
 * answer from guideContent.ts carried every module's coaching words into the
 * first load. The words now load with the coach that shows them. guideContent
 * re-exports both names, so every other reader is unchanged.
 */

/** Route path → module guide key. Add an entry to give a route its coach. */
export const PATH_TO_MODULE: Record<string, string> = {
    '/dashboard': 'dashboard',
    '/sales': 'sales',
    '/receivables': 'sales',
    '/purchases': 'purchases',
    '/expenses': 'expenses',
    '/bank-statements': 'banking',
    '/bank-reconciliation': 'banking',
    '/bank-feeds': 'banking',
    '/inventory': 'inventory',
    '/items': 'inventory',
    '/products': 'inventory',
    '/reports': 'reports',
    '/payroll': 'payroll',
    '/compliance': 'compliance',
    '/compliance-reports': 'compliance',
    '/contacts': 'contacts',
    '/accounts': 'accounts',
    '/journals': 'accounts',
};

export function getModuleKeyForPath(pathname: string): string | null {
    return PATH_TO_MODULE[pathname] ?? null;
}
